import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteBlog } from "../../api/apiBlogs";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف مدونة (soft delete)
 */
export function useDeleteBlog() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteBlogMutate,
        isPending,
    } = useMutation({
        mutationFn: deleteBlog,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["blogs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete blog");
        },
    });

    return {
        deleteBlogMutate,
        isPending,
    };
}
